export default "__VITE_ASSET__BT9bz6ZY__"